
import React, { useEffect, useState } from "react";
import logo from "../../../assets/logo.png";
import colorIcon from "../../../assets/color_icon.svg";
import userIcon from "../../../assets/user.svg";
import artistImage from "../../../assets/artist_image.svg";
import homeImage from "../../../assets/home_image.svg";
import { NavLink } from "react-router-dom";
import { getAuthUser } from "../../../utils/GetAuthUser";
import requestContestIcon from "../../../assets/contest_request_icon.svg";
import dollerIcon from "../../../assets/dollar_icon.svg";
import { FiX } from "react-icons/fi";

export const ArtistSidebar = ({ isOpen, setOpenMenu }) => {

const [isReffrelArtist, setIsReffrelArtist] = useState(false);
  const authUser = getAuthUser();
  const createdStatusCode = 140;

  useEffect(() => {
    if (authUser?.user?.referral_code > 0) {
      setIsReffrelArtist(true);
    } else {
      setIsReffrelArtist(false);
    }
  }, [authUser]);

  // Common items (always visible)
  const commonItems = [
    { path: "/artist", label: "Home", icon: homeImage },
    { path: "/artist/artist-list", label: "Artists", icon: artistImage },
    { path: `/artist/profile/${authUser.userId}`, label: "Profile Details", icon: userIcon },

  ];

  // Conditional items based on referral artist
  const referralItems = isReffrelArtist
    ? [
      
      { path: "/artist/your-contest", label: "Your Contests", icon: colorIcon }]
    : [
        { path: "/artist/user-requests", label: "User Requests", icon: requestContestIcon },
        { path: `/artist/contests/${createdStatusCode}`, label: "All Contests", icon: colorIcon },
        { path: "/artist/my-rewards", label: "My Rewards", icon: dollerIcon },
      ];

  const menuItems = [...commonItems.slice(0, 1), ...referralItems, ...commonItems.slice(1)];



  return (
    <>
      <div
        className={`fixed top-0 left-0 h-full w-[200px] bg-white border-r border-border_color pt-5 pb-2  z-50 transform transition-transform duration-300
      ${isOpen ? "translate-x-0" : "-translate-x-full"} md:translate-x-0`}
      >
        <div className="relative w-full h-full flex flex-col items-center">
          {/* Close btn */}
          <div className="px-2 flex items-center justify-end md:hidden w-full">
            <button onClick={() => setOpenMenu(false)}>
              <FiX size={24} />
            </button>
          </div>

          {/* Logo */}
          <div className="flex items-center justify-center">
            <div className="w-16 h-16">
              <img
                src={logo}
                alt="Loading"
                className="w-full h-full object-contain"
              />
            </div>
          </div>

          {/* Navigation Part */}
          <div className="pt-4  w-full flex items-center justify-center">
            <ul className="flex flex-col">
              {menuItems.map((item) => (
                <li key={item.path} className="relative mb-[6px]">
                  <NavLink
                    to={item.path}
                    end={
                      item.path === "/user" ||
                      item.path === "/artist" ||
                      item.path === "/admin"
                    }
                    className={({ isActive }) =>
                      `px-[24px] py-3 flex items-center justify-start gap-2 outline-none  rounded-[10px]  ${
                        isActive
                          ? "text-white font-bold bg-primary"
                          : "text-black hover:bg-primary hover:text-white"
                      }`
                    }
                  >
                    {({ isActive }) => (
                      <>
                        {isActive && (
                          <span className="absolute -left-3 top-1/2 transform -translate-y-1/2 h-5 w-[3px] bg-primary rounded-r-md"></span>
                        )}
                        <img src={item.icon} alt="icon" className="w-5 h-5" />
                        <span className="font-medium text-xs font-grotesk tracking-wider">
                          {item.label}
                        </span>
                      </>
                    )}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Overlay for mobile */}
      {isOpen && (
        <div
          onClick={() => setOpenMenu(false)}
          className="fixed inset-0 bg-black/40 z-40 md:hidden"
        ></div>
      )}
    </>
  );
};
